var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"column":""}},[_c('v-layout',{attrs:{"row":"","align-center":""}},[_c('ima-logo'),_c('v-spacer'),_c('settings-menu'),_c('account-dropdown')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }